import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirm-box-create-payment',
  templateUrl: './confirm-box-create-payment.component.html',
  styleUrls: ['./confirm-box-create-payment.component.css']
})
export class ConfirmBoxCreatePaymentComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmBoxCreatePaymentComponent>,
    private router: Router) {
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClick()
  {
    this.router.navigate(['/All/payment']);
  }

}
